import type { CustomerOrganization } from "@/Modules/Models/Domain/User";

import { getMeOrganization } from "@/Services/TherapyApi/Users";

import useUserStore from "../Store";

import CustomerTransformerTransformer from "@/Modules/Transformers/CustomerOrganization";

import { hasValue } from "@/Utils/Objects";

async function getOrganizationActionHandler(): Promise<CustomerOrganization | null> {
  const userStore = useUserStore();

  if (hasValue(userStore.user)) {
    const organization = await getMeOrganization().catch(() => null);

    if (hasValue(organization)) {
      userStore.organization = CustomerTransformerTransformer.toDomain(organization);
    } else {
      userStore.organization = null;
    }
  } else {
    userStore.organization = null;
  }

  return userStore.organization;
}

export default getOrganizationActionHandler;
